/**
 * Parking class
 */
export default class {
  constructor (data) {
    this.name = data.name
    this.extension = data.extension
    this.slots = data.slots
    this.slotsObject = data.slots.split(',').map((slot) => { return { isFree: true, Space: slot } })
    this.parkedCalls = data.parked_calls
  }
}
